import _debounce from 'lodash.debounce';
import EventBus from '@/event-bus';

export default {
  data() {
    return {
      hideFilters: true,
    };
  },
  methods: {
    // Delay applying filters
    applyFilters: _debounce(function () {
      if (this.useStoreFilters !== false) {
        if (this.searchTerm !== '' && this.hideFilters !== false) {
          // Save the general filter to the store
          this.$store.dispatch('setFilters', {
            name: this.$route.name,
            filters: {
              general: this.searchTerm,
            },
          });
        } else {
        // Save the regular filters to the store
          this.$store.dispatch('setFilters', {
            name: this.$route.name,
            filters: this.filters,
          });
        }
      }
      EventBus.$emit('refresh-table');
      this.$nextTick(() => this.$refs.vuetable && this.$refs.vuetable.refresh());
    }, 100),

    showFilters() {
      this.applyFilters();
      this.hideFilters = !this.hideFilters;
      EventBus.$emit('refresh-table');
    },

    resetFilters() {
      Object.entries(this.filters).forEach((entry) => {
        const key = entry[0];
        const val = entry[1];
        if (Array.isArray(this.filters[key])) {
          this.filters[key] = [];
        } else {
          // Reset string filters to empty strings, and other types to null.
          this.filters[key] = typeof val === 'string' ? '' : null;
        }
      });

      // Update the filters in the store
      if (this.useStoreFilters !== false) {
        this.$store.dispatch('setFilters', {
          name: this.$route.name,
          filters: this.filters,
        });
      }

      EventBus.$emit('refresh-table');
    },

    // isActiveFilter is passed to the activeFilters computed property.
    // Here we check each filter type and return the expected value (true/false).
    isActiveFilter(filter) {
      let active = false;
      switch (typeof filter) {
        case 'string':
          // Empty strings return false.
          active = filter !== '';
          break;
        case 'object':
          // Null returns false. (indeterminate state on checkbox with 3 values).
          if (filter === null) {
            break;
          } else {
            // When the filter is an array, empty arrays return false. Empty objects return false.
            active = Array.isArray(filter) ? !!filter.length : filter !== {};
          }
          break;
        case 'boolean':
          // Both true and false values are considered active filters.
          active = true;
          break;
        default:
          break;
      }
      return active;
    },
  },

  computed: {
    activeFilters() {
      // Returns true when there is one or more active filters
      return !!Object.values(this.filters).filter(this.isActiveFilter).length;
    },
  },

  filters: {
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

  mounted() {
    if (this.useStoreFilters !== false) {
      const storeFilters = this.$store.state.filtersStore.filters[this.$route.name];
      if (storeFilters && storeFilters.general) {
        this.searchTerm = this.$store.state.filtersStore.filters[this.$route.name].general;
      } else if (storeFilters) {
        this.searchTerm = '';
        this.filters = this.$store.state.filtersStore.filters[this.$route.name];
      }
    }
  },
};
